// extracted by mini-css-extract-plugin
export default {"video__container":"Video_video__container__0GyuR","video__component":"Video_video__component__cLK4d"};